export const modal = {
    slots: {
        content: 'divide-y-0',
        title: 'font-normal text-2xl',
        body: 'text-neutral-700 text-sm',
    },
}
